import type { TFunction } from 'i18next';

import type { DefaultChurnSurvey } from '@hotjar/webapp/domains/revenue/churn-survey/types';

export const getDefaultChurnSurvey = (t: TFunction): DefaultChurnSurvey => ({
  downgradeReason: {
    question: t('revenue:churn-survey.form.downgrade-reason.question'),
    answer: '',
    uuid: '',
    options: [
      {
        text: t('revenue:churn-survey.form.downgrade-options.dont-use-hotjar-enough'),
        id: 'dont-use-hotjar-enough',
      },
      {
        text: t('revenue:churn-survey.form.downgrade-options.too-little-traffic'),
        id: 'too-little-traffic',
      },
      {
        text: t('revenue:churn-survey.form.downgrade-options.missing-feature'),
        id: 'missing-feature',
      },
      {
        text: t('revenue:churn-survey.form.downgrade-options.using-another-tool'),
        id: 'using-another-tool',
      },
      {
        text: t('revenue:churn-survey.form.downgrade-options.technical-issues'),
        id: 'technical-issues',
      },
      {
        text: t('revenue:churn-survey.form.downgrade-options.too-expensive'),
        id: 'too-expensive',
      },
      {
        text: t('revenue:churn-survey.form.downgrade-options.temporary-pause'),
        id: 'temporary-pause',
      },
      {
        text: t('revenue:churn-survey.form.downgrade-options.covid-19'),
        id: 'covid-19',
      },
      {
        text: t('revenue:churn-survey.form.downgrade-options.finished-project'),
        id: 'finished-project',
      },
      {
        text: t('revenue:churn-survey.form.downgrade-options.no-value'),
        id: 'no-value',
      },
      {
        text: t('revenue:churn-survey.form.downgrade-options.other'),
        id: 'other',
      },
    ],
  },
  downgradeExplanation: {
    question: t('revenue:churn-survey.form.downgrade-explanation.question'),
    answer: '',
    uuid: '',
  },
  likelyToUpgrade: {
    question: t('revenue:churn-survey.form.likely-to-upgrade.question'),
    answer: '',
    uuid: '',
    options: [
      {
        text: 'Yes',
        id: 'yes',
      },
      {
        text: 'No',
        id: 'no',
      },
    ],
  },
});
